
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/tables/book",
      function () {
        return require("private-next-pages/tables/book/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/tables/book"])
      });
    }
  